import { render, staticRenderFns } from "./FSvg.vue?vue&type=template&id=12e3d870&"
import script from "./FSvg.vue?vue&type=script&lang=js&"
export * from "./FSvg.vue?vue&type=script&lang=js&"
import style0 from "./FSvg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports